import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  withIcon?: boolean;
  glow?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  withIcon = false,
  glow = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-heading font-bold uppercase tracking-wider transition-all duration-300 transform hover:-translate-y-1 active:translate-y-0 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-gradient-to-r from-brand-fire to-brand-red text-white hover:from-purple-500 hover:to-violet-600 border-b-4 border-purple-900',
    secondary: 'bg-brand-amber text-white hover:bg-pink-400 border-b-4 border-pink-700',
    outline: 'bg-transparent border-2 border-brand-amber text-brand-amber hover:bg-brand-amber/10'
  };
  const sizes = {
    sm: 'text-sm px-4 py-2',
    md: 'text-base px-6 py-3',
    lg: 'text-lg px-8 py-4',
    xl: 'text-xl md:text-2xl px-10 py-5'
  };
  const glowClass = glow ? 'animate-pulse-glow shadow-[0_0_20px_rgba(124,58,237,0.5)]' : '';
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${glowClass} ${widthClass} ${className}`} {...props} data-id="element-205">
      {children}
      {withIcon && <ArrowRight className="ml-2 h-5 w-5 md:h-6 md:w-6" data-id="element-206" />}
    </button>;
}